/**
 * 统考路由信息
 */
export default {
  name: 'unifiedexamination',
  path: 'unifiedexamination',
  component: resolve => require(['../../components/pages/unifiedexamination'], resolve),
  redirect: 'unifiedexamination/reviewScore',
  children: [{
    name: 'preAdjustSign',
    path: 'preAdjustSign',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/sign'], resolve)
  }, {
    name: 'preAdjustSignResult',
    path: 'preAdjustSignResult',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/sign/Result'], resolve)
  }, {
    name: 'preAdjustSignEdit',
    path: 'preAdjustSignEdit',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/signEdit'], resolve)
  }, {
    name: 'preAdjustSignEditResult',
    path: 'preAdjustSignEditResult',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/signEdit/Result'], resolve)
  }, {
    name: 'preAdjustMaterialDownload',
    path: 'preAdjustMaterialDownload',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/PreAdjustMaterialDownload'], resolve)
  }, {
    name: 'preAdjustEnrollResult',
    path: 'preAdjustEnrollResult',
    component: resolve => require(['../../components/pages/unifiedexamination/preAdjust/PreAdjustEnrollResult'], resolve)
  }, {
    name: 'reviewScore',
    path: 'reviewScore',
    component: resolve => require(['../../components/pages/unifiedexamination/UnifiedExaminationScoreReview'], resolve)
  }, {
    name: 'healthReport',
    path: 'healthReport',
    component: resolve => require(['../../components/pages/unifiedexamination/reexamine/UnifiedExaminationHealthReport'], resolve)
  }, {
    name: 'materialSubmit',
    path: 'materialSubmit',
    component: resolve => require(['../../components/pages/unifiedexamination/reexamine/UnifiedExaminationMaterialSubmit'], resolve)
  }, {
    name: 'materialDownload',
    path: 'materialDownload',
    component: resolve => require(['../../components/pages/unifiedexamination/reexamine/UnifiedExaminationMaterialDownload'], resolve)
  }, {
    name: 'queryResult',
    path: 'queryResult',
    component: resolve => require(['../../components/pages/unifiedexamination/reexamine/UnifiedExaminationQueryResult'], resolve)
  }]
}



// WEBPACK FOOTER //
// ./src/router/pages/unifiedexamination.js